import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import { isPdfUrl } from '../lib/vendorCertificate';

/**
 * Сертификат вендора: картинка или PDF. Картинку можно открыть крупно.
 */
const VendorCertificateImage = ({ vendor, className = 'w-48 h-48' }) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const url = (vendor?.certificate || '').trim();
  if (!url) return null;
  const name = (vendor?.name || 'вендора').trim();
  const label = `Сертификат ${name}`;

  const lightbox = lightboxOpen ? (
    <div
      className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4"
      data-testid="vendor-certificate-lightbox"
      onClick={() => setLightboxOpen(false)}
      role="dialog"
      aria-modal="true"
      aria-label={label}
    >
      <div className="relative max-w-5xl w-full max-h-full" onClick={(e) => e.stopPropagation()}>
        {isPdfUrl(url) ? (
          <iframe src={url} title={label} className="w-full h-[85vh] rounded-lg bg-white" />
        ) : (
          <img src={url} alt={label} className="max-w-full max-h-[90vh] mx-auto object-contain" />
        )}
        <Button
          type="button"
          variant="secondary"
          size="icon"
          className="absolute top-2 right-2"
          onClick={() => setLightboxOpen(false)}
          aria-label="Закрыть"
        >
          <X className="w-4 h-4" />
        </Button>
      </div>
    </div>
  ) : null;

  if (isPdfUrl(url)) {
    return (
      <>
        <div
          className={`${className} rounded-xl flex flex-col items-stretch justify-center flex-shrink-0 overflow-hidden border border-border/50 bg-muted/30`}
          data-testid="vendor-certificate"
        >
          <button
            type="button"
            className="flex h-full min-h-[10rem] flex-col text-left"
            onClick={() => setLightboxOpen(true)}
            aria-label={`${label}, подробнее`}
          >
            <iframe
              src={`${url}#toolbar=0&navpanes=0`}
              title={label}
              className="pointer-events-none h-full w-full flex-1 bg-white"
            />
            <span className="px-3 py-2 text-center text-xs font-medium text-accent">Подробнее</span>
          </button>
        </div>
        {lightbox}
      </>
    );
  }

  return (
    <>
      <div
        className={`${className} rounded-xl flex flex-col items-center justify-center flex-shrink-0 overflow-hidden`}
        data-testid="vendor-certificate"
      >
        <button
          type="button"
          className="flex h-full w-full flex-col items-center cursor-pointer group"
          onClick={() => setLightboxOpen(true)}
          aria-label={`${label}, подробнее`}
        >
          <img src={url} alt={label} className="w-full flex-1 object-contain p-4" />
          <span className="px-3 py-2 text-center text-xs font-medium text-accent group-hover:underline">
            Подробнее
          </span>
        </button>
      </div>
      {lightbox}
    </>
  );
};

export default VendorCertificateImage;
